import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tab, Nav } from "react-bootstrap";
import TransactionList from "../TransactionList/TransactionList";
import Gift from "../Gift/Gift";
import Redeem from "../Redeem/Redeem";
import Rewards from "../Rewards/Rewards";
import { useDispatch, useSelector } from "react-redux";
import { getAllTransactionAction, getFilteredTransactionAction, getFilteredTransactionActionTransaction } from "../../../store/actions/transaction/TransactionActions";
import ShimmerLoader from "../../pages/ShimmerLoader/ShimmerLoader";
import InstoreRedeem from "../InstoreRedeem/InstoreRedeem";


const Transaction = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [searchKey, setSearchKey] = useState(""); //  display_name, email, phone, city
  const [trx_type, setTrx_type] = useState("all");
  const [transactionType, setTransactionType] = useState("all"); // all, gifting, redeem, reward
  const [orderDirection, setOrderDirection] = useState("DESC"); // 'ASC', 'DESC'
  const [moduleName, setModuleName] = useState("transaction"); // employee, customer, transaction
  const [orderBy, setOrderBy] = useState("created_at");
  const { loading, error, transactions, totalCount } = useSelector((state) => state.transaction);

  const tabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    setSearchValue("");
    setSearchKey("");
    switch (tab) {
      case "all":
        setTransactionType("all");
        setTrx_type("all");
        break;
      case "Gift":
        setTransactionType("gifting");
        setTrx_type("gifting");
        break;
      case "Redeem":
        setTransactionType("redeem");
        setTrx_type("redeem");
        break;
      case "Rewards":
        setTransactionType("reward");
        setTrx_type("reward");
        break;
      case "In Store Redeem":
        setTransactionType("in_store_redeem");
        setTrx_type("in_store_redeem");
        break;
      default:
        setTransactionType("all");
        setTrx_type("all");
        break;
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [activeTab, currentPage]);

  const fetchTransactions = () => {
    const payload = {
      page_number: currentPage,
      last_three_trx: false,
      order_direction: orderDirection,
      order_by: orderBy,
      trx_type: trx_type,
    };

    if (searchValue && searchKey) {
      let filterPayload = {
        module_name: moduleName,
        search_key: searchKey,
        search_value: searchValue,
        page_number: currentPage,
        transaction_type: "all",
      };
      dispatch(getFilteredTransactionActionTransaction(filterPayload, navigate));
    } else {
      dispatch(getAllTransactionAction(payload, navigate));
    }
  };

  const handlePageChange = (increment) => {
    setCurrentPage((prevPage) => Math.max(1, prevPage + increment));
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    if (searchValue && searchKey) {
      let filterPayload = {
        module_name: moduleName,
        search_value: searchValue,
        search_key: searchKey,
        page_number: 1,
        transaction_type: transactionType,
      };
      dispatch(getFilteredTransactionActionTransaction(filterPayload, navigate));
    }
  };

  const onFormReset = () => {
    setSearchValue("");
    setSearchKey("");
    setCurrentPage(1);
    let payload = {
      page_number: currentPage,
      role: 0,
      order_direction: orderDirection,
      order_by: orderBy,
      trx_type: trx_type,
    };
    dispatch(getAllTransactionAction(payload, navigate));
  };

  const handleChange = (e) => {
    setSearchKey(e.target.value);
  };

  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Transactions</Link>
          </li>
          {/* <li className='breadcrumb-item'>
            <Link to={"#"}>All Transactions</Link>
          </li> */}
        </ol>
      </div>

      <div className='row '>
        <div className='col-lg-12'>
          <div className='card'>
            <Tab.Container activeKey={activeTab} onSelect={tabChange}>
              <div className='d-flex justify-content-between align-items-center border-end  pe-3 py-2'>
                <Nav as='ul' className='nav nav-tabs px-4'>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='all'>All</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='Gift'>Gift</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='Redeem'>Redeem</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='Rewards'>Rewards</Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li' className='nav-item'>
                    <Nav.Link eventKey='In Store Redeem'>In Store Redeem</Nav.Link>
                  </Nav.Item>
                </Nav>

                <form className='d-flex' onSubmit={onFormSubmit} onReset={onFormReset}>
                  <select name='searchKey' value={searchKey} className='form-select me-2' style={{ width: "fit-content" }} id='inputRole' onChange={(e) => handleChange(e)}>
                    <option value='' disabled>
                      Select One
                    </option>
                    <option value='display_name'>Name</option>
                    <option value='transaction_id'>Transaction ID</option>
                    {/* <option value='transaction_type'>Transaction Type</option> */}
                    {/* <option value='status'>Status</option> */}
                    <option value='phone'>Phone Number</option>
                  </select>

                  <div className='position-relative flex-grow-1 me-2'>
                    <input className='form-control ps-4 pe-5' type='text' name='searchValue' value={searchValue} maxLength={30} placeholder='Search' aria-label='Search' onChange={(e) => setSearchValue(e.target.value)} />
                  </div>
                  <button className='btn btn-primary mx-1' type='submit' disabled={!searchKey || !searchValue}>
                    Search
                  </button>
                  <button type='reset' className='btn btn-outline-secondary mx-1' onClick={onFormReset} disabled={!searchKey || !searchValue}>
                    Clear
                  </button>
                </form>
              </div>

              <Tab.Content>
                <Tab.Pane eventKey='all'>
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <TransactionList transactions={transactions} loading={loading} />}
                  {!loading && transactions.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
                <Tab.Pane eventKey='Gift'>
                  {/* {loading && <ShimmerLoader width='95%' height='20%' count={3} />} */}
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <Gift transactions={transactions} loading={loading} />}
                  {!loading && transactions.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
                <Tab.Pane eventKey='Redeem'>
                  {/* {loading && <ShimmerLoader width='95%' height='20%' count={3} />} */}
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <Redeem transactions={transactions} loading={loading} />}
                  {!loading && transactions.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
                <Tab.Pane eventKey='Rewards'>
                  {/* {loading && <ShimmerLoader width='95%' height='20%' count={3} />} */}
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <Rewards transactions={transactions} loading={loading} />}
                  {!loading && transactions.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
                <Tab.Pane eventKey='In Store Redeem'>
                  {/* {loading && <ShimmerLoader width='95%' height='20%' count={3} />} */}
                  {!loading && error && <div className='alert alert-danger'>Error loading transactions</div>}
                  {!loading && <InstoreRedeem transactions={transactions} loading={loading} />}
                  {!loading && transactions.length > 0 && <Pagination currentPage={currentPage} totalCount={totalCount} onPageChange={handlePageChange} />}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </>
  );
};

const Pagination = ({ currentPage, totalCount, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / 10);

  return (
    <>
      <div className='d-flex justify-content-end align-items-center px-4 py-2'>
        <div className='d-sm-flex justify-content-end align-items-center ms-3 mt-3 mb-3'>
          <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center' id='example2_paginate'>
            <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => currentPage > 1 && onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
            <span className='mx-2'>
              Page {currentPage} of {totalPages}
            </span>
            <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => currentPage < totalPages && onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transaction;
